import {useEffect, useCallback, useRef} from 'react';


const Prevent = (props) => {
    const ref = useRef(null);
    let initialPageX = 0;
    let initialPageY = 0;
    const handleTouchStart = useCallback((e) => {
        initialPageX = e.changedTouches[0].pageX;
        initialPageY = e.changedTouches[0].pageY;
    });
    const preventDefault = useCallback((e) => {
        e.stopPropagation();
        if (e.changedTouches.length > 1) {
            e.preventDefault();
        }else{
            const deltaX = e.changedTouches[0].pageX - initialPageX;
            const deltaY = e.changedTouches[0].pageY - initialPageY;
            if (e.cancelable && Math.abs(deltaX) > Math.abs(deltaY)) {
                e.preventDefault();
            }
        }
    });
    useEffect(() => {
        if (ref.current) {
            ref.current.addEventListener('touchstart', handleTouchStart);
            ref.current.addEventListener('touchmove', preventDefault);
        }
        return () => {
            if (ref.current) {
                ref.current.removeEventListener('touchstart', handleTouchStart);
                ref.current.removeEventListener('touchmove', preventDefault);
            }
        };
    }, []);
    return (
        <div ref={ref}>
            {props.children}
        </div>
    );
};

export default Prevent;